module.exports = __webpack_public_path__ + "images/psp/mini/families.svg";